export const indexFingerCover = (ctx: CanvasRenderingContext2D, leatherColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor

  // 手入れ口部分
  ctx.beginPath()
  ctx.moveTo(318, 444) // 左下
  ctx.quadraticCurveTo(327, 460, 415, 425) // 右下
  ctx.quadraticCurveTo(375, 268, 375, 268) // 右上
  ctx.quadraticCurveTo(316, 295, 300, 281) // 左上
  ctx.quadraticCurveTo(318, 444, 318, 444) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.0
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(372, 275) // 左下
  ctx.quadraticCurveTo(410, 423, 410, 423) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#282828'
}

export const indexAndMiddleRightFingerOfBeltBackStyle = (ctx: CanvasRenderingContext2D, leatherColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor

  // 手入れ口部分
  ctx.beginPath()
  ctx.moveTo(276, 119) // 左上
  ctx.quadraticCurveTo(234, 280, 289, 450) // 左下
  ctx.quadraticCurveTo(395, 416, 439, 448)
  ctx.quadraticCurveTo(483, 388, 483, 387)
  ctx.quadraticCurveTo(418, 357, 393, 285) // 指カバー右上あたり
  ctx.quadraticCurveTo(366, 199, 385, 120) // 人差し指＿右上
  ctx.quadraticCurveTo(389, 95, 372, 97)
  ctx.quadraticCurveTo(317, 97, 307, 144) // 人差し指・中指の間の溝
  ctx.quadraticCurveTo(308, 112, 276, 119)
  ctx.fill()
  // 人差し指・中指の間の溝のライン
  ctx.moveTo(307, 144) // 左上
  ctx.quadraticCurveTo(294, 206, 297, 266)
  ctx.stroke()
  ctx.closePath()

  // // stitchここから
  ctx.lineWidth = 1.0
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 中指の縦
  ctx.moveTo(281, 127) // 左上
  ctx.quadraticCurveTo(244, 280, 293, 442) // 左下
  // ctx.quadraticCurveTo() //

  // 中指・人差し指・親指袋
  // 内側
  ctx.moveTo(272, 125) // 中指袋の頂点
  ctx.quadraticCurveTo(301, 122, 297, 149) //
  ctx.quadraticCurveTo(289, 192, 288, 273) //
  ctx.quadraticCurveTo(306, 270, 306, 270) // 中指と人差し指の溝
  ctx.quadraticCurveTo(307, 196, 316, 151) //
  ctx.quadraticCurveTo(324, 105, 355, 105) // 人差し指の頂点
  ctx.quadraticCurveTo(380, 98, 375, 118) //
  ctx.quadraticCurveTo(358, 179, 376, 253) //
  ctx.quadraticCurveTo(400, 358, 472, 395) // 人差し指袋と親指袋のつなぎ目部分

  // 外側
  ctx.moveTo(272, 122) // 中指袋の頂点
  ctx.quadraticCurveTo(307, 117, 300, 147) //
  ctx.quadraticCurveTo(296, 190, 292, 268) //
  ctx.quadraticCurveTo(306, 269, 302, 263) // 中指と人差し指の溝
  ctx.quadraticCurveTo(303, 194, 312, 149) //
  ctx.quadraticCurveTo(322, 103, 355, 101) // 人差し指の頂点
  ctx.quadraticCurveTo(385, 94, 382, 116) //
  ctx.quadraticCurveTo(363, 177, 382, 251) //
  ctx.quadraticCurveTo(404, 356, 476, 390) // 人差し指袋と親指袋のつなぎ目部分

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#282828'
}
